var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 63,
    viewBox: "0 0 55 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.424 34.1791C12.6762 34.1791 0.847168 45.9668 0.847168 60.6631C0.847168 61.7347 1.76891 62.6532 2.84427 62.6532C3.91963 62.6532 4.84137 61.7347 4.84137 60.6631C4.84137 48.2631 14.9805 38.0063 27.5776 38.0063C40.0211 38.0063 50.3138 48.11 50.3138 60.6631C50.3138 61.7347 51.2356 62.6532 52.3109 62.6532C53.3863 62.6532 54.308 61.7347 54.308 60.6631C53.8472 45.9668 42.0182 34.1791 27.424 34.1791Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.424 31.8828C36.1805 31.8828 43.2472 24.8409 43.2472 16.1149C43.2472 7.38901 36.0269 0.500122 27.424 0.500122C18.6675 0.500122 11.6008 7.5421 11.6008 16.268C11.6008 24.9939 18.6675 31.8828 27.424 31.8828ZM27.424 4.32728C34.0298 4.32728 39.4066 9.68531 39.4066 16.268C39.4066 22.8507 33.8762 28.0557 27.424 28.0557C20.9718 28.0557 15.4414 22.6977 15.4414 16.1149C15.4414 9.53222 20.8182 4.32728 27.424 4.32728Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBig);
export default __webpack_public_path__ + "static/media/accountBig.90b8e11ea7b7029623f964c0aad0a5ee.svg";
export { ForwardRef as ReactComponent };